export default class ImplementationError extends Error {
  constructor(e = "Erreur technique survenue, nous nous engageons à gérer l'erreur très vite") {
    super(e)
    this.name = 'Implementation Error'
  }
}
